import React from "react";
import { Carousel } from 'react-bootstrap';
import "./certificateinoptician.css";


import CCourseimg1 from '../../assets/Pathway.jpg';
import CCourseimg2 from '../../assets/courseheaderimg1.png';
import CCourseimg3 from '../../assets/courseheaderimg2.png';
import CCourseimg4 from '../../assets/courseheaderimg3.png';


function CertificateInOptician() {
  return (
    <>


      <div className="banner-certificate">
        {/* Auto Sliding Banner */}
        <Carousel className="mb-5">
          <Carousel.Item>
            <img
              className="d-block w-100 "
              src={CCourseimg1}
              alt="First slide"
            />
  
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={CCourseimg2}
              alt="Second slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={CCourseimg3}
              alt="Third slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={CCourseimg4}
              alt="Fourth slide"
            />
          </Carousel.Item>
        </Carousel>
      </div>

    <div className="certificate-container">
      <div className="header">
        <h1>Certificate in Ophthalmic Assistant</h1>
        <p>
          A comprehensive one-year program designed for beginners, equipping
          them with fundamental knowledge and skills to assist Optometrists and
          Ophthalmologists.
        </p>
      </div>

      <div className="section">
        <h2>Eligibility</h2>
        <p>
          The candidate must meet one of the following criteria:
        </p>
        <ul>
           <li>Have Passed G.C.E. Ordinary Level</li>

            <li>The candidate should have completed the Certificate Level in Ophthalmic Optician at the Eye Care Institute</li>
          <li>
              Minimum 5 years of industry experience
          </li>
         
        </ul>
      </div>

      <div className="section">
        <h2>Duration</h2>
        <p>
          <strong>One (01) Year</strong> - Includes a written examination, oral test,
          and practical examination.
        </p>
      </div>


     <section className="section">
        <h2>Course Fee</h2>
        <p>Admission Fee: 50,000 LKR</p>
        <p>Per Module: 300,000 LKR</p>
        <p>Scholarship Programme Available | Terms and Conditions Applied</p>
      </section>


      <div className="section">
        <h2>Course Content</h2>
        <ul>
          <li>Module 01 - General Science</li>
          <li>Module 02 - Optics</li>
          <li>Module 03 - Anatomy & Physiology of Eye</li>
          <li>Module 04 - Common Eye Diseases</li>
          <li>Module 05 - Clincal Optics & Refraction</li>
          <li>Module 06 - Understanding Ophthalmic equipments</li>
          <li>Module 07 - Ophthalmic Lenses & Frames</li>
          <li>Module 08 - Prescription & Ocular Measurements</li>
          <li>Module 09 - Sales & Marketing</li>
        </ul>


      </div>

      <div className="section">
        <h2>Scope</h2>
        <p>
          This course is designed for beginners and enables them to work as
          assistants to Optometrists and Ophthalmologists. It does not qualify
          for independent practice.
        </p>
      </div>

      <div className="section">
        <h2>Evaluation Pattern</h2>
        <ul>
          <li>Continuous Assignment</li>
          <li>Assignment</li>
          <li>VIVA VOCE</li>
          <li>Final Exam (Theory & Practical)</li>
        </ul>
      </div>
    </div>

    <div className="how-to-apply-container">
      <h2 className="section-title">How to Apply</h2>
      <div className="steps-container">
        <div className="step">
          <div className="circle orange">
          <span>&#x270F;</span>
          </div>
          <h3 className="step-title">REGISTRATION</h3>
          <p>
            <a
              href="/registration-course"
              style={{ textDecoration: 'none' }}
            >
              To Register
            </a>
          </p>
        </div>

        {/* <div className="step">
        <div className="circle green">
          <span>&#128441;</span>
        </div>
         <h3 className="step-title">Guidelines</h3>
        <a href="/Guidelines.pdf" download className="download-button" style={{ textDecoration: 'none' }}>
          Download Guidelines
        </a>
        <div className="download-pdf"></div> 
      </div> */}

      </div>
      <div className="contact-us">
        <a href="/contactus" className="contact-button text-decoration-none">
          Contact Us <span>&#x2192;</span>
        </a>
      </div>
    </div>


    </>
    
  );
}

export default CertificateInOptician;
